import { fetchOrganizations, fetchOrganizationInfo } from "@/api/landing";

export default {
  namespaced: true,
  state: {
    organizations: {},
    pagination: {
      currentPage: 1,
      total: 0,
      perPage: 10,
      lastPage: 1,
    },
    organizationInfo: {},
    isOrganizationsLoading: false,
    isOrganizationInfoLoading: false,
    hasError: false,
  },
  mutations: {
    SET_ORGANIZATIONS(state, payload) {
      state.organizations = payload;
      state.pagination = {
        currentPage: payload.current_page,
        total: payload.total,
        perPage: payload.per_page,
        lastPage: payload.last_page,
        nextPage: payload.next_page_url,
      };
      state.hasError = false;
    },
    SET_ORGANIZATION_INFO(state, organizationInfo) {
      state.organizationInfo = organizationInfo;
    },
    SET_ORGANIZATIONS_LOADING(state, loading) {
      state.isOrganizationsLoading = loading;
    },
    SET_ORGANIZATION_INFO_LOADING(state, loading) {
      state.isOrganizationInfoLoading = loading;
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
  },
  actions: {
    loadOrganizations({ commit, state }, { page = 1, filters = {} } = {}) {
      if (
        state.pagination.currentPage === page &&
        state.organizations?.data?.length > 0
      ) {
        return Promise.resolve();
      }

      return fetchOrganizations({ page, ...filters })
        .then((response) => {
          commit("SET_ORGANIZATIONS", response.data);
        })
        .catch((error) => {
          commit("SET_ERROR", true);
          console.error("Ошибка загрузки организаций:", error);
          return Promise.reject(error);
        });
    },

    loadOrganizationInfo({ commit }, organizationId) {
      commit("SET_ERROR", false);

      return fetchOrganizationInfo(organizationId)
        .then((response) => {
          commit("SET_ORGANIZATION_INFO", response.data);
        })
        .catch((error) => {
          commit("SET_ERROR", true);
          console.error("Ошибка загрузки информации об организации:", error);
          return Promise.reject(error);
        });
    },
  },
  getters: {
    getOrganizations: (state) => state.organizations || [],
    getPagination: (state) => state.pagination || {},
    getOrganizationInfo: (state) => state.organizationInfo || {},
    isOrganizationsLoading: (state) => state.isOrganizationsLoading,
    isOrganizationInfoLoading: (state) => state.isOrganizationInfoLoading,
    hasError: (state) => state.hasError,
  },
};
